import {DKK, Goal, PackageTemplate, Partner, Partners} from ".";
import {RRDate, RRDuration} from "../../..";

export interface IService {
  id: number;
  name: string;
  duration: RRDuration;
}

interface IsFreeConsultationAble {
  freeConsultation: boolean;
}

export class Service implements IService, IsFreeConsultationAble {
  private _goal: Goal | undefined;
  private partners: Partners = [];
  private _packages: PackageTemplate[] = [];

  public id: number;
  public name: string;
  public duration: RRDuration;
  public freeConsultation: boolean;

  constructor(id: number, name: string, duration: number, freeConsultation = false) {
    this.id = id;
    this.name = name;
    this.duration = this.duration = new RRDuration({minutes: duration});
    this.freeConsultation = freeConsultation;
  }

  public addPackage = (pckg: PackageTemplate): void => {
    if (this._packages.find((thisPackage) => thisPackage.id === pckg.id) === undefined) {
      this._packages = [...this._packages, pckg];
    }
  };

  public addPackages(packages: PackageTemplate[]): void {
    packages.forEach((pckg) => this.addPackage(pckg));
  }

  public addGoal = (goal: Goal): Service => {
    if (this._goal === undefined) {
      this._goal = goal;
    }
    return this;
  };

  public addPartner = (partner: Partner, price: DKK): Service => {
    if (this.partners.find((thisPartner) => thisPartner.id === partner.id) === undefined) {
      this.partners = [...this.partners, partner];
      partner.addServiceType(this, price);
    }
    return this;
  };

  public get cheapestPartner(): Partner {
    return this.partners.reduce((cheapestPartner, currentPartner) => {
      return currentPartner.getPrice(this) < cheapestPartner.getPrice(this) ? currentPartner : cheapestPartner;
    }, this.partners[0]);
  }

  public getDates = (allDatesLoaded: RRDate[]): RRDate[] => {
    return allDatesLoaded.filter((date) => this.partners.some((partner) => partner.canServiceBeProvidedOnDate(date, this)));
  };

  doesProvide(date: RRDate): boolean {
    const aPartnerCover = this.partners.some((p) => p.canServiceBeProvidedOnDate(date, this));
    return aPartnerCover;
  }

  public get isDisabled(): boolean {
    const anyPartnerHasTime = this.getPartnersBy().some((p: Partner) => {
      return p.hasTimeslots === true;
    });
    return !anyPartnerHasTime;
  }

  public getPartnersBy(date?: RRDate): Partners {
    if (!date) return this.partners;
    const partners = this.partners.filter((partner) => partner.canServiceBeProvidedOnDate(date, this));
    return partners;
  }

  // public getPartnersBy(date?: RRDate): Partners {
  //   return date ? this.partners.filter((partner) => partner.getDates(this).find((dwt) => dwt.date.equals(date))) : this.partners;
  // }

  public get goal(): Goal {
    if (this._goal === undefined) throw new Error("No goal is set");

    return this._goal;
  }

  public get packages(): PackageTemplate[] {
    return [...this._packages];
  }

  /**
   * @param service - to compare current service against
   * @returns true if ids are matching
   */
  public equals(service: Service): boolean {
    return this.id === service.id;
  }
}
